const LogoExclamationRectangle = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 1227 2730'
      aria-hidden='true'
      focusable='false'
    >
      <path
        d='M0 2580 553.603 0 1226.9 135 673.301 2730 0 2580Z'
        fill='#F8F0E8'
      />
    </svg>
  );
};
export default LogoExclamationRectangle;
